import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import RenewableConsulting from "./pages/RenewableConsulting";
import RenewableServiceDetail from "./pages/RenewableServiceDetail";
import RegulatoryConsultancy from "./pages/RegulatoryConsultancy";
import RegulatoryDetail from "./pages/RegulatoryDetail";
import LegalAdvisory from "./pages/LegalAdvisory";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Team from "./pages/Team";
import PartnersCustomers from "./pages/PartnersCustomers";
import Newsletter from "./pages/Newsletter";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import BlogEditor from "./pages/BlogEditor";

import SEOHead from "./components/SEOHead";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SEOHead />
        <Routes>
          {/* Public Routes with Header/Footer */}
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/about" element={<><Header /><About /><Footer /></>} />
          <Route path="/services" element={<><Header /><Services /><Footer /></>} />
          <Route path="/renewable-consulting" element={<><Header /><RenewableConsulting /><Footer /></>} />
          <Route path="/renewable/:slug" element={<><Header /><RenewableServiceDetail /><Footer /></>} />
          <Route path="/regulatory-consultancy" element={<><Header /><RegulatoryConsultancy /><Footer /></>} />
          <Route path="/regulatory/:slug" element={<><Header /><RegulatoryDetail /><Footer /></>} />
          <Route path="/legal-advisory" element={<><Header /><LegalAdvisory /><Footer /></>} />
          <Route path="/projects" element={<><Header /><Projects /><Footer /></>} />
          <Route path="/projects/:slug" element={<><Header /><ProjectDetail /><Footer /></>} />
          <Route path="/team" element={<><Header /><Team /><Footer /></>} />
          <Route path="/partners-customers" element={<><Header /><PartnersCustomers /><Footer /></>} />
          <Route path="/newsletter" element={<><Header /><Newsletter /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          <Route path="/blog" element={<><Header /><Blog /><Footer /></>} />
          <Route path="/blog/:slug" element={<><Header /><BlogPost /><Footer /></>} />
          
          {/* Admin Routes without Header/Footer */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/blog/new" element={<BlogEditor />} />
          <Route path="/admin/blog/edit/:id" element={<BlogEditor />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
